import React from 'react';

const AllSalesExpenses = () => {
    return (
        <div>
            <h2>All Sales Expenses coming soon</h2>
        </div>
    );
};

export default AllSalesExpenses;